import brands from '@/brands.json';
import config from '@/config';

// The build gives each brand its own static head (brand-html.js). This only
// swaps the title and description per page, which Google picks up when it
// renders the page.

export const hostBrand = config.isTreatwellDomain
  ? brands.treatwellExpert
  : brands.salonized;

const upsertMeta = (key: 'name' | 'property', id: string, content: string) => {
  let tag = document.head.querySelector<HTMLMetaElement>(
    `meta[${key}="${id}"]`,
  );
  if (!tag) {
    tag = document.createElement('meta');
    tag.setAttribute(key, id);
    document.head.appendChild(tag);
  }
  tag.content = content;
};

// Without a title the page falls back to the brand's home title
export const setPageMeta = ({
  title,
  description,
}: {
  title?: string;
  description?: string;
} = {}) => {
  const fullTitle = title
    ? `${title} | ${hostBrand.name}`
    : `${hostBrand.name} | ${hostBrand.tagline}`;
  const fullDescription = description || hostBrand.description;

  document.title = fullTitle;
  upsertMeta('name', 'description', fullDescription);
  upsertMeta('property', 'og:title', fullTitle);
  upsertMeta('property', 'og:description', fullDescription);
  upsertMeta(
    'property',
    'og:url',
    `${window.location.origin}${window.location.pathname}`,
  );
};
